export default __webpack_public_path__ + "static/media/亞洲色情網.8f2c056e.png";